import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import api from "../../lib/api";

export const RelatedOrisa = ({ currentSlug, count = 4 }) => {
  const [all, setAll] = React.useState([]);

  React.useEffect(() => {
    api.get("/orisa").then((r) => setAll(r.data || [])).catch(() => {});
  }, []);

  const withPages = all.filter((o) => o.slug);
  const currentIndex = withPages.findIndex((o) => o.slug === currentSlug);

  // Rotate through the list starting after the current one for variety
  const related = [];
  for (let i = 1; related.length < count && i < withPages.length; i++) {
    const item = withPages[(currentIndex + i) % withPages.length];
    if (item.slug !== currentSlug) related.push(item);
  }

  if (related.length === 0) return null;

  return (
    <section className="bg-night text-cream border-t border-cream/10" data-testid="related-orisa">
      <div className="max-w-6xl mx-auto px-6 py-20">
        <Reveal>
          <p className="uppercase tracking-[0.25em] text-xs text-gold-soft mb-3">Continue the Journey</p>
          <h2 className="font-serif text-4xl text-cream mb-10">Explore Related Òrìṣà</h2>
        </Reveal>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {related.map((o, i) => (
            <Reveal key={o.slug} delay={(i % 4) * 0.06}>
              <Link
                to={`/orisa/${o.slug}`}
                data-testid={`related-orisa-${o.slug}`}
                className="group block rounded-2xl overflow-hidden border border-cream/10 bg-night-surface hover:border-gold/50 transition-colors h-full"
              >
                <div className="relative aspect-[4/5] overflow-hidden">
                  <img
                    src={o.image}
                    alt={o.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-night via-night/20 to-transparent" />
                </div>
                <div className="p-5">
                  <div className="flex items-start justify-between gap-2">
                    <div>
                      <h3 className="font-serif text-2xl text-gold leading-tight">{o.name}</h3>
                      <p className="text-cream/60 text-sm mt-1">{o.domain}</p>
                    </div>
                    <ArrowUpRight className="w-5 h-5 text-cream/40 group-hover:text-gold transition-colors shrink-0" />
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
        <Reveal>
          <Link
            to="/orisa"
            data-testid="related-orisa-view-all"
            className="inline-flex items-center gap-2 mt-10 text-sm font-semibold text-gold hover:text-gold-light transition-colors"
          >
            View the full Òrìṣà Encyclopedia
            <ArrowUpRight className="w-4 h-4" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default RelatedOrisa;
